import {OnInit, Input, EventEmitter, Output} from '@angular/core';
import {environment} from '../../../../environments/environment';
import {Observable} from 'rxjs/Observable';
import {SafeUrl, DomSanitizer} from '@angular/platform-browser';
import {
  IMDocument,
  FidjiDocumentActionNatifService,
  FidjiDocumentWebService,
  FidjiNatifLibraryService
} from '@immanens-com/fidji-api-module';
import {PublicationControllerService} from '../../../core/services/publication/publication-controller.service';
import {DocumentControllerService} from '../../../core/services/document/document-controller.service';
import {UserControllerService} from '../../../core/services/user/user-controller.service';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';

export abstract class AbstractDocumentViewComponent implements OnInit {

  public downloading = false;
  public haveBeenDownloadedBefore: Observable<boolean>;
  public isInUserOffer: Observable<boolean>;
  public documentDate: Date;
  public userIsLogged: Observable<boolean>;
  coverUrl: SafeUrl;
  protected coverSize = 'small';

  private _documentInput: IMDocument;
  @Input() set documentInput(document: IMDocument) {

    if (document !== undefined && document != null) {
      this._documentInput = document;

      this.coverUrl = this.getCoverUrl();
      this.haveBeenDownloadedBefore = this.documentCtrl.haveBeenDownloadedBefore(document.dly_doc_id);
      this.isInUserOffer = this.documentCtrl.isInUserOffer(document.dly_doc_id);

      if (document.doc_display_date != null) {
        this.documentDate = new Date(document['doc_display_date']);
      } else {
        this.documentDate = new Date(document['doc_release_date']);
      }

      this.checkDocumentState();

      this.prepareComponent();
    }

  }
  get documentInput(): IMDocument {
    return this._documentInput;
  }

  public imageLoaded$ = new BehaviorSubject<number>(0);

  constructor(protected libraryService: FidjiNatifLibraryService,
              protected documentAction: FidjiDocumentActionNatifService,
              protected sanitizer: DomSanitizer,
              protected documentCtrl: DocumentControllerService,
              protected userControllerService: UserControllerService) {}

  ngOnInit() {
    this.userIsLogged = this.userControllerService.isLoggedChange;
    this.documentAction.documentInDownloading.subscribe(documentInDownloading => {
      this.updateDocumentState(documentInDownloading);
    });
  }
  public coverBackground() {
    return this._documentInput.base_cover_url + '/cover-' + 'medium' + '.jpg';
  }
  public imageLoaded(event) {
    //console.log('Image loaded');
    this.imageLoaded$.next(1);
  }

  private updateDocumentState(document: IMDocument) {

    if (document != null && document !== undefined) {

      if (this._documentInput == null || this._documentInput === undefined) {
        return; // /!\ object can be null or undefined on the first call to subscribre
      }

      if (document.dly_doc_id === this.documentInput.dly_doc_id) {

        this.documentInput.state = document.state * 100; // x100 for displayin %

        if (0 < this.documentInput.state || this.documentInput.state < 200  ) {
          this.downloading = true;
        } else {
          this.downloading = false;
        }
      }
    }

  }

  /**
   * Check if document exist in library and update document in this case
   */
  private checkDocumentState() {

    if (this.documentInput == null || this.documentInput === undefined) {
      return; // /!\ object can be null or undefined on the first call to subscribre
    }

    const libraryDoc = this.libraryService.documentInLibraryFor(this.documentInput);

    if (libraryDoc != null && libraryDoc !== undefined &&
      libraryDoc.state != null && libraryDoc.state !== undefined) {
      this.documentInput.state = libraryDoc.state;
    } else {
      this.documentInput.state = 0;
    }
  }

  public getCoverUrl(): SafeUrl {

    let url = '';

    if (this._documentInput.state === 200) {

      url = 'local://' + 'getcover/'
        + 'dly-doc-id/' + this.documentInput.dly_doc_id + '/'
        + 'cover.jpg';

    } else {

      url =  this.documentInput.base_cover_url + 'cover-' + this.coverSize + '.jpg';

    }

    return this.sanitizer.bypassSecurityTrustUrl(url);

  }

  protected prepareComponent() {}
}



// WEBPACK FOOTER //
// ./src/app/shared/document-view/abstract-document-view/abstract-document-view.component.ts